import { nextStepCredStepper, updateApplicationContextFromApi, updateUserContextFromApi } from "../../configs/utils";
import SharedPropsService from "../../SharedPropsService";
import { api } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import { ROUTE } from "../../routes";
import AsyncStorage from "@react-native-async-storage/async-storage";
export const onLoad = async (action, _datastore, { navigate, network }) => {
    console.warn("*** onLoad action triggered ***", action);
    const currentRouteId = action?.routeId;
    await updateUserContextFromApi(network);
    const _user = await SharedPropsService.getUser();
    const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : _user?.linkedApplications[0]?.applicationId;
    //don't put await, No need to check and wait for response,
    network.get(`${api.checkCibilCheck}${applicationId}`, {
        headers: await getAppHeader(),
    }, async () => { return; }, {
        disableDefault: true
    });
    const interval = setInterval(async () => {
        await updateApplicationContextFromApi(network, applicationId, true);
        const updatedUser = await SharedPropsService.getUser();
        const routeObj = await nextStepCredStepper(updatedUser?.linkedApplications[0]?.currentStepId);
        if (currentRouteId !== routeObj.routeId) {
            clearInterval(interval);
            await navigate(routeObj?.routeId, routeObj?.params);
        }
    }, 5000);
};
export const helpAction = async (action, _datastore, { navigate, network }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
